/**
 * Brand validation schemas using Zod
 */

import { z } from 'zod';

export const CreateBrandSchema = z.object({
  brandName: z
    .string()
    .trim()
    .min(1, 'Brand name is required')
    .max(100, 'Brand name must be at most 100 characters'),
  contactPerson: z
    .string()
    .min(1, 'Contact person is required')
    .max(100, 'Contact person must be at most 100 characters'),
  email: z.string().email('Invalid email format'),
  phone: z.string().max(20).optional(),
  website: z.string().url('Invalid URL format').optional().or(z.literal('')),
  logoUrl: z.string().url().optional().or(z.literal('')),
  industry: z.string().max(100).optional(),
  notes: z.string().max(2000).optional(),
  relationshipStatus: z.enum(['new', 'active', 'inactive', 'blocked']).optional(),
});

export const UpdateBrandSchema = z.object({
  brandName: z
    .string()
    .trim()
    .min(1, 'Brand name is required')
    .max(100, 'Brand name must be at most 100 characters')
    .optional(),
  contactPerson: z
    .string()
    .min(1, 'Contact person is required')
    .max(100, 'Contact person must be at most 100 characters')
    .optional(),
  email: z.string().email('Invalid email format').optional(),
  phone: z.string().max(20).optional(),
  website: z.string().url('Invalid URL format').optional().or(z.literal('')),
  logoUrl: z.string().url().optional().or(z.literal('')),
  industry: z.string().max(100).optional(),
  notes: z.string().max(2000).optional(),
  relationshipStatus: z.enum(['new', 'active', 'inactive', 'blocked']).optional(),
});
